import {
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Spin,
} from "antd";
import React from "react";
import { BatchItemStatus } from "../../Services/ItemsService";
import { useClient } from "../../Context/ClientContext";
import { dayjs } from "../../../Utilities/dayjs";
import { useLocation } from "react-router-dom";
import { Utils } from "../../../Utilities/Utils";

const AddBatchItemsModal: React.FC<{
  open: boolean;
  onCancel: any;
  setBatchData: (param: any) => void;
  id?: string | undefined;
  batchData: any;
  setBatchOpnQty: (param: any) => void;
  batchOpnQty?: any;
  allBatchData: any;
  setAllBatchData: (param: any) => void;
  oldItem: any;
}> = (props) => {
  const [form] = Form.useForm();
  const location = useLocation();
  const { currentClient } = useClient();
  const [totalOpeningQuantity, setTotalOpeningQuantity] = React.useState<any>();
  const [data, setData] = React.useState<any>();
  const [batchDetails, setBatchDetails] = React.useState<any[]>();
  const [qty, setQty] = React.useState<number>();
  const [loading, setLoading] = React.useState(false);
  const handleValuesChange = (changedValues: any, allValues: any) => {
    const batches = allValues?.batches ?? [];
    console.log("Batches:", batches);
    setData(batches);
    const total = batches.reduce((sum: number, batch: any) => {
      return location.pathname.split("/")[4] === "sales" ||
        location.pathname.split("/")[4] === "purchase"
        ? sum + (Number(batch?.currentQty ? batch?.currentQty : 0) || 0)
        : sum +
            (Number(
              batch?.availableQty ? batch?.availableQty : batch?.openingQuantity
            ) || 0);
    }, 0);
    console.log("Total Opening Quantity:", total);
    setTotalOpeningQuantity(total);
  };

  console.log("batchData", props?.batchData);
  console.log("batchData", props?.batchData);

  const saveData = async () => {
    try {
      if (await form.validateFields()) {
        props?.setBatchData(data ?? batchDetails ?? props?.batchData);
        props?.setAllBatchData(data ?? batchDetails ?? props?.batchData);
        setQty(totalOpeningQuantity ?? props?.batchOpnQty);
        props?.setBatchOpnQty(
          totalOpeningQuantity === 0 ? props?.batchOpnQty : totalOpeningQuantity
        );

        props?.onCancel(false);
      }
    } catch (errorInfo) {
      console.log("Validation Failed:", errorInfo);
      setQty(undefined);
      props?.setBatchOpnQty(undefined);
    }
  };

  console.log("allBatchData", props?.allBatchData);
  React.useEffect(() => {
    const getData = async () => {
      const matchItems = props?.allBatchData || [];
      setQty(props?.batchData?.inventoryItem?.openingStock?.quantity);
      setBatchDetails(matchItems);
      console.log("itm", matchItems);
      setLoading(false);

      if (matchItems && matchItems.length > 0) {
        debugger;
        form.setFieldsValue({
          batches: matchItems
            // .filter((d: any) => d?.baseType === 0)
            .map((d: any) => ({
              batchNumber: d?.batchNumber,
              currentQty: d?.availableQty ? d?.availableQty : d?.currentQty,
              MFDate: d?.MFDate
                ? dayjs(d?.MFDate)
                : d?.mfDate
                ? dayjs(d?.mfDate)
                : "",
              expiryDate: dayjs(d?.expiryDate),
              openingQuantity: d?.availableQty
                ? d?.availableQty
                : d?.openingQuantity,
              salesPrice: d?.salesPrice,
              purchasePrice: d?.purchasePrice,
              status: BatchItemStatus[d?.status],
            })),
        });
      }
    };

    getData();
  }, [props?.allBatchData, form]);

  React.useEffect(() => {
    if (props?.batchData?.length) {
      const totalOpeningQuantity = props?.batchData?.reduce(
        (sum: any, d: any) => {
          return sum + (Number(d?.availableQty) || 0);
        },
        0
      );
      if (
        location.pathname.split("/")[4] !== "sales" &&
        location.pathname.split("/")[4] !== "purchase"
      ) {
        setTotalOpeningQuantity(totalOpeningQuantity);
        // setTotalOpeningQuantity(0);
      } else {
      }
      form.setFieldsValue({
        batches: props.batchData.map((d: any) => ({
          batchNumber: d?.batchNumber,
          MFDate: d?.MFDate
            ? dayjs(d?.MFDate)
            : d?.mfDate
            ? dayjs(d?.mfDate)
            : "",
          expiryDate: d?.expiryDate ? dayjs(d?.expiryDate) : "",
          openingQuantity: d?.availableQty
            ? d?.availableQty
            : d?.openingQuantity,
          // currentQty: d?.openingQuantity,
          salesPrice: d?.salesPrice,
          currentQty: d?.availableQty ? d?.availableQty : d?.currentQty,
          purchasePrice: d?.purchasePrice,
          status: d?.status,
        })),
      });
    }
  }, [props?.batchData]);

  console.log("props?.batchOpnQty", props?.batchOpnQty);

  console.log("qty", qty);
  console.log("totalOpeningQuantity", totalOpeningQuantity);

  return (
    <div>
      <Modal
        width={1200}
        onCancel={() => props?.onCancel(false)}
        open={props?.open}
        title="Add Stock - Batches"
        footer={
          <>
            <Row gutter={12} justify={"end"}>
              <Col>
                <Button onClick={() => props.onCancel(false)}>Cancel</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={
                    ["sales", "purchase"].includes(
                      location.pathname.split("/")[4]
                    )
                      ? saveData
                      : saveData
                  }
                >
                  {location.pathname.split("/")[4] === "sales" ||
                  location.pathname.split("/")[4] === "purchase"
                    ? "Done"
                    : "Save"}
                </Button>
              </Col>
            </Row>
          </>
        }
      >
        {location.pathname.split("/")[4] === "sales" ||
        (location.pathname.split("/")[4] === "purchase" &&
          (!props?.allBatchData || props?.allBatchData.length === 0)) ? (
          <></>
        ) : (
          <>
            <Spin spinning={loading} indicator={<LoadingOutlined />}>
              <>
                <Row justify={"end"}>
                  <Col>
                    <h4>
                      {props?.id ? "Total Available Qty" : "Opening Qty"} $
                      {totalOpeningQuantity === undefined ||
                      totalOpeningQuantity === 0
                        ? Utils.getFormattedNumber(props?.batchOpnQty, 3)
                        : Utils.getFormattedNumber(totalOpeningQuantity, 3) ??
                          Utils.getFormattedNumber(qty, 3) ??
                          0}
                    </h4>
                  </Col>
                </Row>
                <Form
                  form={form}
                  initialValues={{
                    batches: [{}],
                  }}
                  onValuesChange={handleValuesChange}
                  style={{ maxHeight: "60vh", overflowY: "scroll" }}
                >
                  <table
                    className="AddPageTabelDesign"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>Batch No.</th>
                        <th>MFD. Date</th>
                        <th>Expiry Date</th>
                        {location.pathname.split("/")[4] === "sales" ||
                        location.pathname.split("/")[4] === "purchase" ? (
                          <>
                            <th>Current Qty.</th>
                          </>
                        ) : (
                          <>
                            <th>
                              {props?.id ? "Available Qty" : "Opening Qty."}
                            </th>
                          </>
                        )}
                        {location.pathname.split("/")[4] === "sales" ? (
                          <></>
                        ) : (
                          <th>Purchase Price</th>
                        )}
                        {location.pathname.split("/")[4] === "purchase" ? (
                          ""
                        ) : (
                          <th>Sales Price</th>
                        )}

                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      <Form.List name="batches">
                        {(fields, { add, remove }) => (
                          <>
                            {fields.map((field, name) => (
                              <tr key={field.key}>
                                <td style={{ width: "15%" }}>
                                  <Form.Item
                                    name={[name, "batchNumber"]}
                                    className="m-0"
                                    // rules={[
                                    //   ({ getFieldValue }) => ({
                                    //     validator(_, value) {
                                    //       const openingQty = getFieldValue([
                                    //         "batches",
                                    //         name,
                                    //         "openingQuantity",
                                    //       ]);
                                    //       if (openingQty && !value) {
                                    //         return Promise.reject(
                                    //           new Error(
                                    //             "Batch No. is required if Opening Qty is entered"
                                    //           )
                                    //         );
                                    //       }
                                    //       return Promise.resolve();
                                    //     },
                                    //   }),
                                    //   {
                                    //     required: true,
                                    //     message: "Please input your Batch No.!",
                                    //   },
                                    // ]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please enter Batch No!",
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder="Batch No."
                                      maxLength={20}
                                    />
                                  </Form.Item>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <Form.Item
                                    name={[name, "MFDate"]}
                                    className="m-0"
                                  >
                                    <DatePicker
                                      placeholder="MFD. Date"
                                      format={"DD/MM/YYYY"}
                                      style={{ width: "100%" }}
                                      disabledDate={(current) =>
                                        current <
                                        dayjs("1900-01-01", "YYYY-MM-DD").add(
                                          -1,
                                          "day"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <Form.Item
                                    name={[name, "expiryDate"]}
                                    className="m-0"
                                    dependencies={[["batches", name, "MFDate"]]}
                                    // rules={[
                                    //   ({ getFieldValue }) => ({
                                    //     validator(_, value) {
                                    //       const mfDate = getFieldValue([
                                    //         "batches",
                                    //         name,
                                    //         "MFDate",
                                    //       ]);

                                    //       if (!value) {
                                    //         return Promise.reject(
                                    //           new Error("Expiry Date is required")
                                    //         );
                                    //       }
                                    //       if (!mfDate) {
                                    //         return Promise.resolve();
                                    //       }
                                    //       if (value.isAfter(mfDate)) {
                                    //         return Promise.resolve();
                                    //       }
                                    //       return Promise.reject(
                                    //         new Error(
                                    //           "Expiry Date must be after MFD. Date"
                                    //         )
                                    //       );
                                    //     },
                                    //   }),
                                    // ]}
                                  >
                                    <DatePicker
                                      placeholder="Expiry Date"
                                      format="DD/MM/YYYY"
                                      style={{ width: "100%" }}
                                      disabledDate={(current) =>
                                        current <
                                        form
                                          .getFieldValue([
                                            "batches",
                                            name,
                                            "MFDate",
                                          ])
                                          ?.startOf("day")
                                      }
                                    />
                                  </Form.Item>
                                </td>
                                {location.pathname.split("/")[4] === "sales" ||
                                location.pathname.split("/")[4] ===
                                  "purchase" ? (
                                  <>
                                    <td style={{ width: "10%" }}>
                                      <Form.Item
                                        name={[name, "currentQty"]}
                                        className="m-0"
                                      >
                                        <InputNumber
                                          min={0}
                                          placeholder="current Qty."
                                          style={{ width: "100%" }}
                                        />
                                      </Form.Item>
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    <td style={{ width: "10%" }}>
                                      <Form.Item
                                        name={[name, "openingQuantity"]}
                                        className="m-0"
                                      >
                                        <InputNumber
                                          min={0}
                                          placeholder="Opening Qty."
                                          style={{ width: "100%" }}
                                          disabled={
                                            props?.oldItem === true
                                              ? false
                                              : true
                                          }
                                        />
                                      </Form.Item>
                                    </td>
                                  </>
                                )}
                                {location.pathname.split("/")[4] === "sales" ? (
                                  <></>
                                ) : (
                                  <td style={{ width: "12%" }}>
                                    <Form.Item
                                      name={[name, "purchasePrice"]}
                                      className="m-0"
                                      rules={[
                                        {
                                          validator: (_, value) => {
                                            if (
                                              value &&
                                              value > 10_00_00_00_000
                                            ) {
                                              return Promise.reject(
                                                new Error(
                                                  "Purchase Price cannot exceed 10 Arab!"
                                                )
                                              );
                                            }
                                            return Promise.resolve();
                                          },
                                        },
                                      ]}
                                    >
                                      <InputNumber
                                        // min={0}
                                        placeholder="Purchase Price"
                                        style={{ width: "100%" }}
                                        type="number"
                                        maxLength={12}
                                        disabled={props?.id ? true : false}
                                      />
                                    </Form.Item>
                                  </td>
                                )}
                                {location.pathname.split("/")[4] ===
                                "purchase" ? (
                                  <></>
                                ) : (
                                  <td style={{ width: "10%" }}>
                                    <Form.Item
                                      name={[name, "salesPrice"]}
                                      className="m-0"
                                      rules={[
                                        {
                                          validator: (_, value) => {
                                            if (
                                              value &&
                                              value > 10_00_00_00_000
                                            ) {
                                              return Promise.reject(
                                                new Error(
                                                  "Sales Price cannot exceed 10 Arab!"
                                                )
                                              );
                                            }
                                            return Promise.resolve();
                                          },
                                        },
                                      ]}
                                    >
                                      <InputNumber
                                        min={0}
                                        placeholder="Sales Price"
                                        type="number"
                                        style={{ width: "100%" }}
                                      />
                                    </Form.Item>
                                  </td>
                                )}

                                {/* {location.pathname.split("/")[4] === "sales" ||
                          location.pathname.split("/")[4] === "purchase" ? (
                            <></>
                          ) : (
                            <td style={{ width: "10%" }}>
                              <Form.Item
                                name={[name, "status"]}
                                className="m-0"
                              >
                                <Select
                                  style={{ width: "100%" }}
                                  options={[
                                    {
                                      value: BatchItemStatus.Available,
                                      label: "Available",
                                    },
                                    {
                                      value: BatchItemStatus.Sold,
                                      label: "Sold",
                                    },
                                    {
                                      value: BatchItemStatus.Expired,
                                      label: "Expired",
                                    },
                                    {
                                      value: BatchItemStatus.Damaged,
                                      label: "Damaged",
                                    },
                                    {
                                      value: BatchItemStatus.Returned,
                                      label: "Returned",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </td>
                          )} */}
                                <td style={{ width: "3%" }} align="center">
                                  <Button
                                    type="text"
                                    danger
                                    disabled={props?.id ? true : false}
                                    icon={<DeleteOutlined />}
                                    onClick={() => remove(field.name)}
                                  />
                                </td>
                              </tr>
                            ))}
                            {props?.id ? (
                              <></>
                            ) : (
                              <>
                                <Row gutter={15} style={{ marginTop: "10px" }}>
                                  <Col>
                                    <Button
                                      type="primary"
                                      size="small"
                                      icon={<PlusOutlined />}
                                      onClick={() => add(fields.length + 1)}
                                    >
                                      Add
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            )}
                          </>
                        )}
                      </Form.List>
                    </tbody>
                  </table>
                </Form>
              </>
            </Spin>
          </>
        )}
      </Modal>
    </div>
  );
};

export default AddBatchItemsModal;
